import r from"styled-components";import{theme as o}from"../../../../../theme.js";const i=r.div`
  background-color: ${o.colors.gray[100]};
  border-radius: ${o.radius}px;
  padding: ${o.spacing*4}px;
  > h1, p {
    margin: 0;
    text-align: center;
  }
  > h1 {
    color: ${o.colors.gray[900]};
    font-size: 20px;
    line-height: 30px;
  }
  > p {
    color: ${o.colors.gray[700]};
    font-size: 14px;
    line-height: 21px;
  }
`;export{i as Container};
